<template>
  <div class="login-vue" style="padding: 20px;">
    <span v-if="!erro">autenticando ...</span>
    <span v-if="erro">problemas ao se autenticar</span>
  </div>
</template>
<script>
const getToken = (accessToken) => {
  const split = accessToken.split('.')[1];

  try {
    return JSON.parse(window.atob(split));
  } catch (e) {
    return false;
  }
};

const getUserRules = (token) => {
  if (token) {
    return token['user.rule'] || [];
  } else {
    return [];
  }
};

export default {
  data() {
    return {
      erro: false
    };
  },
  methods: {
    async getEnumsName() {
      try {
        const { data } = await R.Regras.listarAutorizacoes();
        return data;
      } catch (e) {
        return [];
      }
    }
  },
  mounted: async function () {
    // const query = this.$route.query;
    const params = this.$route.params;

    const resp = await R.SingleSignOn.login({
      token: params.token
    });

    if (resp.ok === false) {
      this.erro = true;
      return;
    }

    if (resp.data) {
      localStorage.clear();
      await this.$nextTick();
      Utils.saveLocal('v360.user', resp.data);
      Utils.trackingF360(this, 'Login', 'SSO');
      const enumNames = await this.getEnumsName();

      if (enumNames) {
        localStorage.setItem('v360.permissao', JSON.stringify(enumNames));
      }

      this.$router.replace('/');
    }
  }
};
</script>
